import { useEffect, useState } from 'react';
import type { ReactNode } from 'react';
import { CommandCtx } from './useCommandPalette';

export function CommandPaletteProvider({ children }: { children: ReactNode }) {
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setOpen((o) => !o);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <CommandCtx.Provider
      value={{
        open: () => setOpen(true),
        close: () => setOpen(false),
        isOpen,
      }}
    >
      {children}
    </CommandCtx.Provider>
  );
}
